import React, {Component} from "react";
import {QRCode} from "react-qrcode-logo";
import {count} from "react-table/src/aggregations";
import ReactToPrint from "react-to-print";
import {INVOICE_CSS, INVOICE_STYLE} from "../../../constant"
import "./DispatchLabel.css";

class DispatchLabel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            labelData: props.BookingDetails || false,
        };
    }

    render() {
        return (
            <div className="card-body">
                <ReactToPrint
                    documentTitle={"Print Dispatch Label"}
                    pageStyle={INVOICE_CSS}
                    copyStyles={false}
                    trigger={() => {
                        return (
                            <button className="col w-100 btn btn-warning btn-multiline btn btn-w-lg align-self-center">
                                <span className="material-icons-outlined fs-35">print</span>
                            </button>
                        );
                    }}
                    content={() => this.componentRef}
                />
                <div className={"d-none"}>
                    <LabelLayout
                        ref={(el) => (this.componentRef = el)}
                        labelData={this.state.labelData}
                    />
                </div>
            </div>
        );
    }
}

export const LabelLayout = React.forwardRef((props, ref) => {
    const data = props.labelData || {};
    const styles =  INVOICE_STYLE
    console.log(data)
    const products = Array.isArray(data.product) ? data.product : [];
    return (
        <div  style={styles.receipt} ref={ref}>
            {/* INFO */}
            <div style={styles.row}><span>Order:</span><span>#{data.id}</span></div>
            <div style={styles.row}><span>Date:</span><span>{data.date}</span></div>
            <hr />
            {/* ITEMS HEADER */}
            <div style={{ ...styles.row, ...styles.bold }}>
                <span style={{ width: "50%" }}>Item({count(products)})</span>
                <span style={{ width: "15%", textAlign: "right" }}>Qty</span>
                <span style={{ width: "35%", textAlign: "right" }}>Amt</span>
            </div>

            <hr />

            {/* ITEMS */}
            {products.map((item, i) => (
                <div key={i} style={styles.row}>
                    <span style={{ width: "50%" }}>{item}</span>
                    <span style={{ width: "15%", textAlign: "right" }}>{data?.qty[i]}</span>
                    <span style={{ width: "35%", textAlign: "right" }}>
            {data?.qty[i] * data?.rate[i]}
          </span>
                </div>
            ))}

            <hr />

            <div style={styles.row}><span>Subtotal</span><span>{data.total_amount}</span></div>

            <div style={styles.row}>
                <span>Advance Amt</span>
                <span>{data?.advance_amount || 0}</span>
            </div>

            <div style={styles.row}>
                <span>Delivery Charge</span>
                <span>{data?.delivery_charger||0}</span>
            </div>

            <hr />

            <div style={{ ...styles.row, ...styles.bold }}>
                <span>Balance Amount</span>
                <span>{data?.balance_amount||0}</span>
            </div>
            <hr />
            {/* CUSTOMER SECTION */}
            <div style={styles.center}>
                <div style={styles.bold}>Address</div>
            </div>
            <div style={styles.row}>
                <span>Customer</span>
                <span>{`${data?.customer} ${data?.alternative_contact?" ,"+data?.alternative_contact:""}`}</span>
            </div>
            <div style={styles.row}>
                <span>Contact</span>
                <span>{data?.contact||""}</span>
            </div>
            <div style={styles.row}>
                <span>Address</span>
                <span>{data?.address||""}</span>
            </div>
            <div style={styles.row}>
                <span>Landmark</span>
                <span>{data?.landmark||""}</span>
            </div>
            <div style={styles.row}>
                {(data.remark || data.message) && (
                    <div>
                        {data.message && <div><span className="bold">Msg:</span> {data.message}</div>}
                        {data.remark && <div><span className="bold">Note:</span> {data.remark}</div>}
                    </div>
                )}
            </div>
            <hr />

            {/* FOOTER */}
            <div style={styles.center}>
                <div>Thank you!</div>
                {/*<div>{CompanyInfo.Website}</div>*/}
                <small>Not an official invoice. Collect original after payment.</small>
            </div>

            <hr/>
            <div style={styles.center}>
                <QRCode
                    value={`Order:${data.id}|Amount:${data.balance_amount}`}
                    size={90}
                    qrStyle="squares"
                    eyeRadius={5}
                />
                <p>SCAN TO PAY</p>
            </div>
        </div>
    );
});
export default DispatchLabel;
